// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"00f86644","977":"a5ce5b85"}[chunkId] + ".chunk.js";
};